var map = {
	"./event_001_EN.js": [
		732,
		732
	],
	"./event_001_RU.js": [
		694,
		694
	],
	"./event_001_TEMPLATE.js": [
		673,
		673
	],
	"./event_002_EN.js": [
		723,
		723
	],
	"./event_002_RU.js": [
		765,
		765
	],
	"./event_003_RU.js": [
		244,
		244
	],
	"./event_004_RU.js": [
		83,
		83
	],
	"./event_005_RU.js": [
		426,
		426
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 412;
module.exports = webpackAsyncContext;